import React, { createContext, useContext, useState, useEffect } from 'react';

const CookieConsentContext = createContext();

export const useCookieConsent = () => {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error('useCookieConsent must be used within CookieConsentProvider');
  }
  return context;
};

export const CookieConsentProvider = ({ children }) => {
  const [showBanner, setShowBanner] = useState(false);
  const [consent, setConsent] = useState({
    essential: true, // Always true, cannot be disabled
    analytics: false,
    marketing: false,
    preferences: false
  });

  useEffect(() => {
    // Check if user has already made a choice
    const savedConsent = localStorage.getItem('cookieConsent');
    if (savedConsent) {
      setConsent(JSON.parse(savedConsent));
    } else {
      // Show banner if no consent saved
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    const allConsent = {
      essential: true,
      analytics: true,
      marketing: true,
      preferences: true
    };
    setConsent(allConsent);
    localStorage.setItem('cookieConsent', JSON.stringify(allConsent));
    setShowBanner(false);
  };

  const acceptEssential = () => {
    const essentialConsent = {
      essential: true,
      analytics: false,
      marketing: false,
      preferences: false
    };
    setConsent(essentialConsent);
    localStorage.setItem('cookieConsent', JSON.stringify(essentialConsent));
    setShowBanner(false);
  };

  const savePreferences = (newConsent) => {
    const savedConsent = {
      essential: true, // Always true
      ...newConsent
    };
    setConsent(savedConsent);
    localStorage.setItem('cookieConsent', JSON.stringify(savedConsent));
    setShowBanner(false);
  };

  const resetConsent = () => {
    localStorage.removeItem('cookieConsent');
    setShowBanner(true);
    setConsent({
      essential: true,
      analytics: false,
      marketing: false,
      preferences: false
    });
  };

  return (
    <CookieConsentContext.Provider
      value={{
        showBanner,
        consent,
        acceptAll,
        acceptEssential,
        savePreferences,
        resetConsent,
        setShowBanner
      }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
};
